<template>

	<div :class="{field:1,invalid:!is_valid}" >

		<label :for="name" class="field_label" v-if="label" >{{ label }}</label>

		<label :for="name" class="field_label_help" v-if="label_help" >{{ label_help }}</label>

		<!-- <FileUploader
			v-if="type == 'file'"
			:name="name"
			v-model="currentVal"
			:formQueue="formQueue"
			/> -->

		<TemplateInput
			ref="input"
			v-if="type == 'template'"
			v-model="currentVal"
			:required="required || null"
			:editable_variables="true"
			/>


		<OrgSelectInput
			ref="input"
			v-else-if="type == 'org'"
			v-model="currentVal"
			/>

		<textarea-autosize
			ref="input"
			v-else-if="type == 'textarea'"
			v-model="currentVal"
			:autocomplete="autocomplete || null"
			:autofocus="autofocus ? 'autofocus' : null"
			:required="required ? 'required' : null"
			:placeholder="placeholder"
			:minHeight="90"
			></textarea-autosize>


		<label
			v-else-if="type == 'checkbox'"
			class="checkbox_label"
			><input
				ref="input"
				type="checkbox"
				v-model="currentVal"
				:name="name"
				/><span>{{ checkbox_label }}</span></label>


		<select
			ref="input"
			v-else-if="type == 'select'"
			v-model="currentVal"
			:name="name"
			:required="required || null"
			><option v-for="option in options" :value="option.value">{{ option.label }}</option></select>


		<input
			v-else
			ref="input"
			v-model="currentVal"
			:type="type || 'text'"
			:name="name"
			:autocomplete="autocomplete || null"
			:placeholder="placeholder"
			:autofocus="autofocus ? 'autofocus' : null"
			:required="required ? 'required' : null"
			/>

		<div v-if="validation_error" class="field_validation_error" >{{ validation_error }}</div>
		
	</div>

</template>

<script>

	import Vue from 'vue'
	import VueTextareaAutosize from 'vue-textarea-autosize'

	Vue.use(VueTextareaAutosize)

	import TemplateInput from '../components/TemplateInput';
	import OrgSelectInput from '../components/OrgSelectInput';
	// import FileUploader from './inputs/FileUploader';

	export default {

		components : {
			TemplateInput,
			OrgSelectInput,
			// FileUploader,
		},

		props : [
			'label',
			'label_help',
			'validateValue',
			'filterValue',
			'autocomplete',
			'value',
			'name',
			'placeholder',
			'options',
			'type',
			'formQueue',
			'autofocus',
			'required',
			'checkbox_label',
		],

		data() {
			return {
				currentVal : null,
				is_valid : false,
				is_mounted : false,
			};
		},


		beforeMount() {
			this.currentVal = this.value;
			this.validate();
		},


		mounted() {
			this.is_mounted = true;
		},

		computed:{
			org_options(){
				return this.orgs.map( t => ({label:t.personal?'Personal projects':t.name,value:t.id}));
			},
		},

		watch: {
			value : function(){
				this.currentVal = this.value;
			},
			currentVal : function(){
				if(this.filterValue){
					this.currentVal = this.filterValue(this.currentVal);
				}
				this.validate();
				this.$emit('input', this.currentVal )
			},
		},

		methods: {
			validate(){
				var validator = this.checkValidity();
				this.is_valid = validator===true;
				this.validation_error = validator===true?null:(validator||'Invalid value');
			},
			checkValidity(){ // Returns
				// if(this.required && !this.currentVal) return false;
				if(!this.required && !this.currentVal) return true;
				if(!this.validateValue) return true;
				return this.validateValue(this.currentVal||'');
			},
		}
	}

</script>